'use client'

import { FC } from 'react'
import PrintedTicket from '@/root/modules/tuuleliinid/PrintedTicket/components/PrintedTicket/PrintedTicket'
import type { TicketData } from '@/root/shared-types/reservation/reservation-types'

export const TicketPrintPage: FC<{ ticketData: TicketData }> = ({ ticketData }) => (
  <div className="ticket-print-avoid-break">
    <PrintedTicket ticketData={ticketData} hideQrCode={ticketData.status === 'BOOKED'} />
  </div>
)
